import React, { useEffect, useRef } from "react";
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import "./YoutubeVideo.scss";

const YoutubeVideo = ({ src }) => {
  const playerRef = useRef(null);

  useEffect(() => {
    if (!playerRef.current) return;

    const player = new Plyr(playerRef.current, {
      controls: [
        "play",
        "progress",
        "current-time",
        "mute",
        "volume",
        "settings",
        "fullscreen",
      ],
      settings: ["speed", "quality"],
      hideControls: false,
      youtube: {
        noCookie: true,
        modestbranding: 1,
        rel: 0,
        showinfo: 0,
      },
    });


    return () => {
      player.destroy();
    };
  }, []);

  return (
    <div className="plyr__video-embed">
      <iframe
        ref={playerRef}
        src={getEmbedUrl(src)}
        allowFullScreen
        allow="autoplay"
        title="Youtube Video"
      />
    </div>
  );
};

const getEmbedUrl = (url) => {
  if (!url) return "";

  let videoId = "";

  if (url.includes("youtu.be")) {
    videoId = url.split("youtu.be/")[1];
  } else if (url.includes("watch?v=")) {
    videoId = url.split("watch?v=")[1];
  } else {
    videoId = url;
  }

  return `https://www.youtube-nocookie.com/embed/${videoId}?controls=0&rel=0&modestbranding=1`;
};

export default YoutubeVideo;
